import { Component, createRef } from "react";
import { connect } from "react-redux";
import {set_datapage} from '@ora/recursos/src/redux/actions/DataPageAction'
import { baseUrl, getValuesQueryArray, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import { Button, Card, Section } from 'react-bulma-components';
import $ from 'jquery'
import dt from 'datatables.net'
import Swal from "sweetalert2";
import {PageLength} from "helpers/Datatables";
$.DataTable = dt

class Plinean extends Component {

    state = {
        list_tipo: "",
        import_vars: [],
        search:{txt_recurso:"",sel_tipo: ""},
        isloadsearch:true,
        total:"",
        isprocesing:false,
        resulth:[]
    }
    
    constructor (props) {
        super(props)
        
        // this.props.set_datapage('Importar otro')
     
        this.props.set_datapage({
            titulo: 'Hologacion a nivel Recursos',
            subTitulo: '',
            isbackend:true,
            breadcrumb:[
                {name:"Intranet",url:"#"},
                {name:"Recoleccion",url:"#"},
                {name:"Hologacion a nivel Recursos",url:"#",active:true},
        ]});
    }
    componentDidMount () {
        axios.get(baseUrl('cites/homologar/tiporecursos')).then(res => {
            if (res.data.success) {                   
                this.init(res.data)
            }
        })
        this.initDatatable()
        
    }
    initDatatable = () => {
        

        const OnClick_acciones = (evt) => {
             let {accion, id,tabla} = evt.currentTarget.dataset
            switch (accion) {
                case 'ver':
                    if(tabla=="plinean_core"){
                        this.props.history.push(localUrl("/recoleccion/homologacion/plinean/?q2=" + id))
                    }else{
                        this.props.history.push(localUrl("/recoleccion/homologacion/darwin/?q2=" + id))
                    }
                
                    break;
                case 'hc':
                    this.requestHomologar('cites',id,tabla)
                    break;
                case 'hi':
                    this.requestHomologar('uicn',id,tabla)
                    break;
                case 'ha':
                    this.requestHomologar('amazonica',id,tabla)
                    break;
                case 'ht':
                    this.requestHomologar('all',id,tabla)
                    break;
            }
        }
        const OnCall = () => {

            this.setState({                   
                isloadsearch: true
            })
            
        }
        const OnFinish = () => {

            this.setState({                   
                isloadsearch: false
            })
            
        }
        
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/homologar/datatable_recurso"),
              data: (d) => {
                
                d.filter = this.getFilter()
                return d
              },
              beforeSend: function () {
                OnCall(); // show wating animation
              },
              error: function (xhr, error, thrown) {
                OnFinish()
                //alert(xhr.status);
                //alert(thrown);
                Swal.fire({
                    title: thrown,
                    html: `
                     <p> Se encontró un error en el servidor, intente más tarde.</p>
                     <p>Mensaje: ${xhr.status} - ${error}</p>
                    `,
                    icon: 'error'
                }).then(sr => {
                    
                  })
                
              }
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
              { data: "rec_int_id" , render: (d, t, r)=>{
                return r.index
              }},
              { data: "rec_txt_name" },
              { data: "rec_txt_description",render: (d, t, r)=>{
                return "<p title='"+d+"'>"+d.substring(0,50)+"...</p"
                }},
              { data: "rec_int_records" },
              { data: "rec_txt_tabla" },            
              { data: "rec_homologado_cites" , render: (d, t, r)=>{if(d){return 'Si'}else{return 'No'}}},
              { data: "rec_homologado_iucn", render: (d, t, r)=>{if(d){return 'Si'}else{return 'No'}}},
              { data: "rec_homologado_amazonico" , render: (d, t, r)=>{if(d){return 'Si'}else{return 'No'}}},
              { data: "rec_int_id", render: (d, t, r) => {
                  return `
                  <div class="buttons is-center">
                  <button data-id="${d}" data-tipo="${r.var_int_id}" data-tabla="${r.rec_txt_tabla}"  data-accion="ver" class="button is-small is-primary btn-acciones" title="ver por Registros">
                      <span class="icon is-small"><i class="fas fa-eye"></i></span>
                  </button>                 
                  <button data-id="${d}" data-tipo="${r.var_int_id}"  data-tabla="${r.rec_txt_tabla}" data-accion="hc" class="button is-small is-primary btn-acciones" title="Homologar Cites">
                      <span class="icon is-small"><i class="fas">HC</i></span>
                  </button>
                  <button data-id="${d}" data-tipo="${r.var_int_id}" data-tabla="${r.rec_txt_tabla}"  data-accion="hi" class="button is-small is-primary btn-acciones" title="Homologar IUCN">
                  <span class="icon is-small"><i class="fas">HU</i></span>
                  </button>
                  <button data-id="${d}" data-tipo="${r.var_int_id}" data-tabla="${r.rec_txt_tabla}"  data-accion="ha" class="button is-small is-primary btn-acciones" title="Homologar Amazónico">
                  <span class="icon is-small"><i class="fas">HA</i></span>
                  </button>
                <button data-id="${d}" data-tipo="${r.var_int_id}" data-tabla="${r.rec_txt_tabla}"  data-accion="ht" class="button is-small is-primary btn-acciones" title="Homologar Todos">
                    <span class="icon is-small"><i class="fas">HT</i></span>
                </button>
              </div> `
              } }
            ],
            drawCallback: (dcall) => {
                this.setState({                   
                    total:dcall._iRecordsDisplay,
                    isloadsearch: false
                })

                $('#tblRecurso_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblRecurso_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblRecurso_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblRecurso_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblRecurso_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblRecurso')
        
        this.datatable = this.table.DataTable(this.configDT).on('click', '.btn-acciones', OnClick_acciones)
    }

    init (response){    

        const itemTipo= response.data.tiporecurso.map((item) => {
            var selected=false
            if(this.state.search['sel_tipo']==item.id){this.state.search['sel_tipo']=item.id;selected=true}
            return (
                <option value={item.id} selected={selected}>{item.name}</option>
            );
        })        
        this.setState({
            list_tipo: itemTipo
        })   
    }
    getFilter(){
        return  {
            q1: this.state.search['txt_recurso'],
            q2: this.state.search['sel_tipo']           
            }
      
    }
    gestionarCambio = (event) => {
        var search=this.state.search
        if (event.target.type === "radio") {
            search[event.target.name]=event.target.value;
        } else {
            search[event.target.id]=event.target.value;
        }
        this.setState({          
            search:search
        })
      };
    
    BuscarRecursos = () => {
        this.setState({  
            isloadsearch: true
        })
        this.datatable.draw()     

    }
    requestHomologar = (value,recurso=0,tabla="") => {
        this.setState({  
            isloadsearch: true,
            isprocesing: true
        })
    
        axios.get(`${this.datatable.ajax.url()}?${$.param(this.datatable.ajax.params())}&homologar=${value}&recurso=${recurso}&tabla=${tabla}`).then(res => {
            this.iteracionHomolagacion(res)
        })
        
    }
    iteracionHomolagacion(res){
        
    }
    finishHomologacion(res){
        if (res.data.success) {
            this.datatable.draw()
            
        }
        Swal.fire({
            title: 'Homologación',
            html: `
                <h3>Resultados</h3>
                <table class="table is-narrow" style="width: 100%">
                
                <tbody>
                  <tr>
                    <td class="has-text-left">Cites</td>
                    <td class="has-text-centered">${res.data.data.cites}</td>
                  </tr>
                  <tr>
                    <td class="has-text-left">IUCN</td>
                    <td class="has-text-centered">${res.data.data.iucn}</td>
                  </tr>
                  <tr>
                    <td class="has-text-left">Amazonica</td>
                    <td class="has-text-centered">${res.data.data.amazonica}</td>
                  </tr>
                  <tr>
                    <td class="has-text-left">Base de datos analizadas</td>
                    <td class="has-text-centered">${res.data.data.recursos}</td>
                  </tr>
                  <tr>
                    <td class="has-text-left">Registros analizados</td>
                    <td class="has-text-centered">${res.data.data.total}</td>
                  </tr>
                </tbody>
              </table>
            `,
            icon: 'success'
        }).then(sr => {
            this.datatable.draw()
            
          })
          this.setState({  
            isloadsearch: false
        })
    }
    onClick_homologarCites = () => {
        this.requestHomologar('cites')
    }
    onClick_homologarIucn = () => {
        this.requestHomologar('uicn')
    }
    onClick_homologarAmazonica = () => {
        this.requestHomologar('amazonica')
    }
    onClick_homologarTodos = () => {
        this.requestHomologar('all')
    }
    
    render() {
        return (
            <section className="section is-main-section">
                <div className="card">
                    <header className="card-header">
                        <p className="card-header-title">
                            <span className="icon"><i className="mdi mdi-finance"></i></span>
                            Proceso de homologación de especies a nivel de recursos disponibles en la base de datos
                        </p>                       
                    </header>
                    <div className="card-content">
                        <p className="has-text-justified">
                            La homologación de las especies registradas a nivel de recursos disponibles en la base de datos, consistes en actualizar o asignar los valores de los apéndices CITES o categorías de la UICN desde fuentes oficiales internacionales respectivamente CITES.ORG y IUCNREDLIST.ORG. 
                            <br/>
                            Primero seleccione el tipo de recurso sobre el cual se va a realizar la homologación, visualiza los recursos disponibles y los estados que se encuentran, finalmente seleccione el proceso de homologación a realizar CITES u IUCN. 
                        </p>
                        <hr/>                       
                    <div className="field is-horizontal">
                        <div className="field-body">
                            <div className="column is-5">
                                <div className="field">
                                    <div className="control has-icons-left has-icons-right">
                                        <input type="text"
                                            autoComplete="on" placeholder="Nombre del recurso" id="txt_recurso" name="txt_recurso" className="input form-control" onChange={this.gestionarCambio}/><span className="icon is-left"><i
                                                className="fas fa-search"></i></span></div>
                                
                                </div>
                            </div>
                            <div className="column is-3">
                            <div className="field">
                                <div className="control">
                                    <span className="select is-empty">
                                        <select ref={ this.refFilterRecursos } id="sel_tipo" name="sel_tipo" onChange={ this.onChange } required="required" onChange={this.gestionarCambio}>
                                            <option  value="-1"> - Tipo de Recurso -
                                            </option>
                                            {this.state.list_tipo}
                                            
                                        </select></span></div>
                            </div>
                            </div>
                        
                            <div className="column">
                                <Button className={"is-success "+(this.state.isloadsearch?"is-loading":"")} onClick={ this.BuscarRecursos}>Buscar</Button>
                            </div>
                        
                        </div>
                    </div>                
                    <hr/>
                    <div className="columns">
                        <div className="column level">
                            <div className="buttons level-right">

                                    <Button type="button" onClick={ this.onClick_homologarCites } className="is-info">Homologar Cites - HC</Button>
                                    <Button type="button" onClick={ this.onClick_homologarIucn } className="is-info">Homologar IUCN - HI</Button>
                                    <Button type="button" onClick={ this.onClick_homologarAmazonica } className="is-info">Homologar Amazonica - HA</Button>
                                    <Button type="button" onClick={ this.onClick_homologarTodos } className="is-info">Homologar Todos - HT</Button>
                            </div>
                        </div>
                        
                    </div>
                    <div className="columns">
                        <div className="column level">                          
                                <div className="level-right">
                                    <div className="level-item">
                                        {this.state.total} registros                                      
                                    </div>
                                </div>
                        </div>
                        
                    </div>
                    <div className="b-table has-pagination">
                        <div className="table-wrapper">
                            <div>
                                <table id="tblRecurso"
                                    className="table is-fullwidth is-bordered is-hoverable is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th className="is-sortable">#</th>
                                            <th>Recurso</th>
                                            <th>Descripción</th>
                                            <th>Registros</th>
                                            <th>Tabla</th>
                                            <th title="Homologado en CITES">CITES</th>
                                            <th title="Homologado en CITES">IUCN</th>
                                            <th title="Homologado como Amazónica">Amazónica</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    </div>
                </div>
                {this.state.isprocesing?(
                <div id="modal-ter" className="modal is-active">
                    <div className="modal-background"></div>
                    <div className="modal-card">
                        <header className="modal-card-head">
                        <h4 className="modal-card-title is-size-4">Procesando Homologación</h4>
                        <button className="delete" aria-label="close"></button>
                        </header>
                        <section className="modal-card-body">
                            <p>fff</p>
                        <progress class="progress is-info" value="45" max="100">45%</progress>
                        </section>
                        <footer className="modal-card-foot">
                       
                        </footer>
                    </div>
                </div>
                ):''
                }
            </section>
            
        )
    }
}

export default connect(null, {set_datapage})(Plinean)